import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withApollo } from 'react-apollo';
import { GetCapacity } from '../../../actions/capacity';
import { bindActionCreators } from 'redux';
import { SetTourID, SetTourName } from '../../../actions/cart';
import { strCount } from '../../../helpers/stringutils';

class CalendarOptions extends PureComponent{

    constructor(props){
        super(props);
        this.state = {
            productName:"",
            isOpen:false
        }
        this.changeHandler = this.changeHandler.bind(this);
        this.onOptionClick = this.onOptionClick.bind(this);
        this.documentClickHandler = this.documentClickHandler.bind(this);
    }

    documentClickHandler(e){
        try{
          if(e.target.offsetParent.className !== "filterDropdown basket" && e.target.offsetParent.className !== "calender"){
            if(this.state.isOpen) this.setState({isOpen: false});
          }
        }catch(e){}
      }

    componentDidMount(){
        const { product:{name}, SetTourID, SetTourName } = this.props;

        //Clear tourid and tourname
        SetTourID("");
        SetTourName("");

        this.setState({productName:name});

        document.body.addEventListener('click', this.documentClickHandler);
    }

    componentWillUnmount(){
        document.body.removeEventListener('click', this.documentClickHandler);
    }

    changeHandler(e, value){

        const { client, SetTourID, SetTourName, iso_currency } = this.props;

        SetTourID(value.tour_id);
        SetTourName(value.name);

        this.setState({productName:value.name, isOpen:false }, () => {
            GetCapacity(client, value.tour_id, iso_currency);
        });
    }

    onOptionClick(e){
        e.preventDefault();
        this.setState({isOpen:!this.state.isOpen});
    }


    render(){
        const { productName, isOpen } = this.state;
        const { product:{options} } = this.props;

        return (
            <div className="clearfix calender-options mt2">
                <div className="col-11 sm-col-10 mx-auto">
                <div className="form round-corners">
                    
                    <label className="pb1">More options available</label>  
                      <div className="filterDropdown basket">
                          <div className="clearfix mxn2">
                              <div className="col-12 px2 mx-auto">
                                <button onClick={ e => this.onOptionClick(e) } className={`filterDropdown-btn calender ${strCount(productName, 33, 'small')}`}>
                                    {productName}
                                    <svg width="20" height="17" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg" className={`${isOpen ? 'active' : ''}`}>
                                        <path fill="#3d3d3d" d="M1683 808l-742 741q-19 19-45 19t-45-19L109 808q-19-19-19-45.5t19-45.5l166-165q19-19 45-19t45 19l531 531 531-531q19-19 45-19t45 19l166 165q19 19 19 45.5t-19 45.5z"/>
                                    </svg>
                                </button>
                           
                              </div>
                              <div className="col col-12 px2 mx-auto">
                              { 
                                isOpen && <ul className="calender">
                                  {
                                    options.map((value, index) => <li value={value.tour_id} onClick={e => this.changeHandler(e, value)} key={index}>{value.name}</li> )
                                  }
                                </ul>
                              }
                              </div>
                          </div>
                      </div>
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => {
  return {
    product:state.product,
    iso_currency:state.currentBooking.iso_currency
  }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        SetTourID,
        SetTourName
    }, dispatch);
} 



export default withApollo(connect(mapStateToProps, mapDispatchToProps)(CalendarOptions)); 
